import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/module/shared.module';

import { SavedFormsService } from '../../services/saved-forms.service';
import { FormsModule } from '@angular/forms';
import { PricingMaskFillerComponent } from './pricing-mask/pricing-mask-filler.component';

@NgModule({
	imports: [CommonModule, SharedModule, FormsModule],
	declarations: [PricingMaskFillerComponent ],
	providers: [SavedFormsService]
})
export class SavedFormsModule {}



// WEBPACK FOOTER //
// ./src/app/component/saved-forms/saved-forms.module.ts